export class Timer {
  private startTime: number = 0;
  private remaining: number;
  private timeoutId: NodeJS.Timeout | null;

  constructor(private callback: () => void, private duration: number) {
    this.remaining = duration;
    this.timeoutId = null;
  }

  start(): void {
    if (this.remaining <= 0) {
      this.callback();
      return;
    }

    this.startTime = Date.now();
    this.timeoutId = setTimeout(() => {
      this.callback();
      this.clear(); // Clear the timeout on execution
    }, this.remaining);
  }

  pause(): void {
    if (this.timeoutId) {
      this.clear();
      this.remaining -= Date.now() - this.startTime;
    }
  }

  resume(): void {
    this.start();
  }

  clear(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
}
